import { Address } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_stable",
        type: "bool",
      },
    ],
    name: "getFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
]

const mainnetAddress = "0x83FE469C636C4081b87bA5b3Ae9991c6Ed104248"
const testnetAddress = "0x4947243CC818b627A5D06d14C4eCe7398A23Ce1A"

const address: Address = IS_MEZO_MAINNET ? mainnetAddress : testnetAddress

export default {
  abi,
  address,
}
